import { Box, Stack, Tabs, Typography } from "@mui/material";
import { ProductInventoryPermission } from "commons/enum/permission";
import { useCheckPermission } from "commons/hooks/use-check-permission";
import { observer } from "mobx-react-lite";
import { useStores } from "mobx-stores/_root-store";
import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { XTab } from "share-components/mui-wrap/tab/x-tab";
import { PageContainer } from "share-components/templates/page/page-container";
import { ProductGoodsIssueList } from "./product-goods-issue-list/product-goods-issue-list";
import { ProductGoodsReceiptList } from "./product-goods-receipt-list/product-goods-receipt-list";
import { ProductInventoryList } from "./product-inventory-list/product-inventory-list";

export const ProductInventory = observer(() => {
  return (
    <PageContainer>
      <Outlet></Outlet>
    </PageContainer>
  );
});
export enum ProductInventoryTab {
  ProductInventory = "ProductInventory",
  ProductGoodsReceipt = "ProductGoodsReceipt",
  ProductGoodsIssue = "ProductGoodsIssue",
}
export const ProductInventoryHome = observer(() => {
  const {
    productInventoryManagement: { tabSelected, setProp },
  } = useStores();
  const { accessKey, allowAccess } = useCheckPermission([
    ProductInventoryPermission.Default,
    ProductInventoryPermission.Import,
    ProductInventoryPermission.Export,
  ]);

  useEffect(() => {
    if (allowAccess && accessKey) {
      const getTabSelected = (accessKey: string) => {
        switch (accessKey) {
          case ProductInventoryPermission.Default:
            return ProductInventoryTab.ProductInventory;
          case ProductInventoryPermission.Import:
            return ProductInventoryTab.ProductGoodsReceipt;
          case ProductInventoryPermission.Export:
            return ProductInventoryTab.ProductGoodsIssue;
          default:
            return null;
        }
      };
      setProp("tabSelected", getTabSelected(accessKey));
    }
  }, [accessKey, allowAccess, setProp]);
  return (
    <Stack
      flex={1}
      direction={"column"}
      spacing={2}
      sx={{ overflow: "hidden" }}
    >
      <Stack direction={"row"}>
        <Typography variant="subtitle2">Quản lý kho thành phẩm</Typography>
      </Stack>
      <Box>
        <Tabs
          value={tabSelected}
          onChange={(_, value) => {
            setProp("tabSelected", value);
          }}
        >
          <XTab
            accessPermission={[ProductInventoryPermission.Default]}
            label="Kho thành phẩm"
            value={ProductInventoryTab.ProductInventory}
          />
          <XTab
            accessPermission={[ProductInventoryPermission.Import]}
            label="Nhập kho"
            value={ProductInventoryTab.ProductGoodsReceipt}
          />
          <XTab
            accessPermission={[ProductInventoryPermission.Export]}
            label="Xuất kho"
            value={ProductInventoryTab.ProductGoodsIssue}
          />
        </Tabs>
      </Box>
      <Stack flex={1} sx={{ overflow: "hidden", paddingBlockStart: 1 }}>
        {tabSelected === ProductInventoryTab.ProductInventory && (
          <ProductInventoryList />
        )}

        {tabSelected === ProductInventoryTab.ProductGoodsReceipt && (
          <ProductGoodsReceiptList></ProductGoodsReceiptList>
        )}

        {tabSelected === ProductInventoryTab.ProductGoodsIssue && (
          <ProductGoodsIssueList></ProductGoodsIssueList>
        )}
      </Stack>
    </Stack>
  );
});
